
import React, { Component } from "react";
import { connect } from "react-redux";
import { isEmpty } from "lodash";

import ContentHeader from "./ContentHeader";
import { list, create, update } from "../actions";
import Table from "../utils/table";
import { SLBTxtBox } from "../utils/Forms";
import { editPreacher, newPreacher } from "../actions/preachers";

class PreacherForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preacher: {},
      errors: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearForm = this.clearForm.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setPreacher(nextProps.currentPreacher);
  }

  setPreacher(data = {}) {
    const preacher = {
      name: data.name || "",
      id: data.id || 0
    };
    this.setState({ preacher });
  }

  clearForm() {
    this.props.newPreacher();
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    let newPreacher = { ...this.state.preacher, [name]: value };
    this.setState({ ...this.state, preacher: newPreacher });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isPreacherValid(this.state.preacher)) {
      this.props.savePreacher(this.state.preacher);
    }
  }

  isPreacherValid(preacher = {}) {
    let errors = {};

    if (isEmpty(preacher.name)) {
      errors["name"] = "Name is required";
    }

    this.setState({ errors });
    return isEmpty(errors);
  }

  render() {
    let { name, id } = this.state.preacher;
    const { errors } = this.state;
    let mode = id > 0 ? "Edit" : "New";
    let buttonText = id > 0 ? "Update" : "Create";

    const title = `${mode} Preacher`;
    return (
      <div>
        <ContentHeader title={title}>
          <span className="pull-right" />
        </ContentHeader>
        <form onSubmit={this.handleSubmit}>
          <div className="clearfix">
            <div className="row">
              <SLBTxtBox
                label="Name"
                name="name"
                value={name}
                context={this}
                attrs={{ errors, klass: "col-md-12" }}
              />
            </div>
            <br />
            <div className="col-md-12 edit-buttons-pane">
              <input
                className="btn btn-success pull-right"
                type="submit"
                value={buttonText}
              />
              <a
                className="btn btn-default pull-right"
                style={{ marginRight: 10 }}
                onClick={this.clearForm}
              >
                Cancel
              </a>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

class PreachersList extends Component {
  render() {
    let {
      preachers,
      loading,
      handleEvent
    } = this.props;

    const tableFields = [
      { name: "name", header: "Name" },
      { name: "edit", type: "action", header: "", action: "editPreacher" }
    ];

    let content;
    if (loading) {
      content = (
        <div className="zero-items">
          <p> Fetching preachers, please wait ... </p>
        </div>
      );
    } else {
      content = <div className="zero-items" />;
    }

    let columnWrappers = {
      view(f) {
        return (
          <span>
            {" "}<i className="fa fa-eye"> </i>{" "}
          </span>
        );
      },
      edit(f) {
        return (
          <span>
            {" "}<i className="fa fa-pencil"> </i>{" "}
          </span>
        );
      }
    };

    if (preachers.length !== 0) {
      content = (
        <div>
          <Table
            tableData={preachers}
            tableFields={tableFields}
            handleEvent={handleEvent}
            columnWrappers={columnWrappers}
          />
          <div />
        </div>
      );
    }

    return (
      <div>
        <ContentHeader title="Preachers">
          <span className="pull-right" />
        </ContentHeader>
        <div>
          {content}
        </div>
      </div>
    );
  }
}

class Preachers extends Component {
  componentDidMount() {
    this.props.fetchPreachers();
    this.handleTableAction = this.handleTableAction.bind(this);
  }

  handleTableAction(eventName, data) {
    this[eventName](data);
  }

  editPreacher(preacher) {
    this.props.editPreacher(preacher);
  }
  render() {
    let { preacher, savePreacher, newPreacher } = this.props;
    return (
      <div>
        <div className="col-md-8">
          <PreachersList
            handleEvent={this.handleTableAction}
            preachers={this.props.preachers}
          />
        </div>
        <div className="col-md-4">
          <PreacherForm
            preacher={preacher}
            savePreacher={savePreacher}
            newPreacher={newPreacher}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { currentPreacher, list } = state.preachers;
  return {
    preachers: list,
    currentPreacher: currentPreacher
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchPreachers() {
      dispatch(list("preachers"));
    },
    newPreacher() {
      dispatch(newPreacher());
    },
    editPreacher(preacher) {
      dispatch(editPreacher(preacher));
    },
    savePreacher(data) {
      if (data.id) {
        dispatch(update("preacher", data));
      } else {
        dispatch(create("preacher", data));
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Preachers);



// WEBPACK FOOTER //
// ./src/components/Preachers.js